import { DefaultService } from '@/services/DefaultService';

export default class PrazopagtoparcelaService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env);
    }

    save(obj) {
        return this._http.post(`${this._env}/vendas/prazopagtoparcela`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    insertBulk(parcelaList, idprazopagto) {
        return this._http.post(`${this._env}/vendas/prazopagtoparcela/insertbulk/${idprazopagto}`, 
            parcelaList, this._headers).then(res => {
                return res.body;
            }, err => {
                this.verifyError(err);
                throw err;
            });
    }

    find(id) {
        return this._http.get(`${this._env}/vendas/prazopagtoparcela/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findAll(idprazopagto) {
        return this._http.get(encodeURI(`${this._env}/vendas/prazopagtoparcela.json?idprazopagto=${idprazopagto}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}